<template>
    <div class="backgroundVideo">
		<h5>Background Video</h5>
		
		<div v-if="hasBackgroundVideo">
			<VideoUploader @file-added="updateFileNames"></VideoUploader>
			<div class="form-group" v-for="(property, size) in componentItemContent['background-video']" :key="size">
				<label>{{ size }}</label>
				<input type="text" class="form-control" :id="size" v-model="componentItemContent['background-video'][size]" >
			</div>
		
		</div>

		<button type="submit" class="btn m-2 icons-round" @click.stop.prevent="addBackgroundVideo">
			<img src="~@/assets/icons/add.svg">
		</button>

		<button type="submit" class="btn m-2 icons-round" @click.stop.prevent="removeBackgroundVideo">
			<img src="~@/assets/icons/minus.svg">
		</button>
 
    </div>
</template>

<script>
    import VideoUploader from './VideoUploader';
	export default {
		components: {
            VideoUploader
        },		
		name: 'BackgroundVideo',
        
		props: ['componentItemContent'],

		data() {
			return {
				hasBackgroundVideo: false,
			}
		},
		
        mounted() {
			if(this.componentItemContent['background-video']) {
				this.hasBackgroundVideo = true;
			}
		},

		methods: {
			updateFileNames:function(fileName){
                var extension = "mp4"
                var filenameWithoutExtension = fileName.split('.').slice(0, -1).join('.')
                this.componentItemContent['background-video']['desktop'] = filenameWithoutExtension + "-desktop." + extension
            },
			addBackgroundVideo() {
				this.componentItemContent['background-video'] = {
					'desktop': ''
				}
				this.hasBackgroundVideo = true;
			},
			removeBackgroundVideo() {
				delete this.componentItemContent['background-video'];
				this.hasBackgroundVideo = false;
			},
		}

    }
</script>

<style lang="scss" scoped>
	@import '@/scss/style.scss';

	.backgroundVideo{
		padding:20px 0;
	}

	label {
		display: block;
	}

	html {
		font-size: 16px;
	}

	.btn:not(:last-of-type) {
		margin-right: 15px;
	}
	
</style>